import { Button } from 'primereact/button'
import { useNavigate, useSearchParams } from 'react-router-dom'
import AppBodyComponent from '../Components/AppBodyComponent'

function DonationSuccess() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const sessionId = searchParams.get('session_id')

    return (
        <AppBodyComponent>
            <div className='flex flex-column gap-3 align-items-center p-4'>
                <div className='text-2xl font-bold'>Donation completed</div>
                <div className='text-center'>
                    {'Thank you for your contribution. Your payment was confirmed by Stripe.'}
                </div>
                {sessionId && <div className='text-sm'>{`Session: ${sessionId}`}</div>}
                <Button label='Back to places' onClick={()=>navigate('/app/user_home_places')} />
            </div>
        </AppBodyComponent>
    )
}

export default DonationSuccess
